import { render, staticRenderFns } from "./PackageContent.vue?vue&type=template&id=014254a2&scoped=true&lang=pug"
import script from "./PackageContent.vue?vue&type=script&lang=js"
export * from "./PackageContent.vue?vue&type=script&lang=js"
import style0 from "./PackageContent.vue?vue&type=style&index=0&id=014254a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014254a2",
  null
  
)

export default component.exports